/**
 * GTR: ヘッダー第2行メニューで「ご利用ガイド」と「オリジナル記事」のブロック順を
 * settings_data.json を変更せず入れ替える（間の項目は相対順を維持）。
 */
(function () {
  function findMainNavUl() {
    return document.querySelector('#menu-main-menu.main-menu');
  }

  function findGuideLi(ul) {
    var links = ul.querySelectorAll('a.cms-item-title');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = (a.getAttribute('href') || '').toLowerCase();
      var text = (a.textContent || '').replace(/\s+/g, '');
      if (
        href.indexOf('user-guide') !== -1 ||
        text.indexOf('ご利用ガイド') !== -1 ||
        text.indexOf('UsageGuide') !== -1
      ) {
        return a.closest('li.menu-item') || a.closest('li');
      }
    }
    return null;
  }

  function findArticleLi(ul) {
    var links = ul.querySelectorAll('a.cms-item-title');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      var text = (a.textContent || '').replace(/\s+/g, '');
      if (text.indexOf('オリジナル記事') !== -1 || text.indexOf('OriginalArticle') !== -1) {
        return a.closest('li.menu-item') || a.closest('li');
      }
      if (href.indexOf('/blogs/') !== -1 && href.indexOf('%E3%82%AA%E3%83%AA%E3%82%B8%E3%83%8A%E3%83%AB') !== -1) {
        return a.closest('li.menu-item') || a.closest('li');
      }
    }
    return null;
  }

  function reorderGuideAndArticle() {
    var ul = findMainNavUl();
    if (!ul) return;

    var guideLi = findGuideLi(ul);
    var articleLi = findArticleLi(ul);
    if (!guideLi || !articleLi || guideLi === articleLi) return;

    var children = Array.prototype.slice.call(ul.children);
    var gi = children.indexOf(guideLi);
    var ai = children.indexOf(articleLi);
    if (gi < 0 || ai < 0) return;
    if (ai < gi) return;

    var slice = [];
    for (var el = guideLi; el; el = el.nextElementSibling) {
      slice.push(el);
      if (el === articleLi) break;
    }
    if (slice.length < 2 || slice[slice.length - 1] !== articleLi) return;

    var ref = guideLi.previousElementSibling;
    var ordered = slice.slice().reverse();
    var frag = document.createDocumentFragment();
    for (var j = 0; j < ordered.length; j++) {
      frag.appendChild(ordered[j]);
    }
    if (ref) {
      ul.insertBefore(frag, ref.nextSibling);
    } else {
      ul.insertBefore(frag, ul.firstChild);
    }
  }

  function run() {
    try {
      reorderGuideAndArticle();
    } catch (e) {
      /* no-op */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
